import { render, staticRenderFns } from "./ShareSettings.vue?vue&type=template&id=3f9caed8&scoped=true"
import script from "./ShareSettings.vue?vue&type=script&lang=js"
export * from "./ShareSettings.vue?vue&type=script&lang=js"
import style0 from "./ShareSettings.vue?vue&type=style&index=0&id=3f9caed8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9caed8",
  null
  
)

export default component.exports